import { inject, NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "@shared/auth";

const routes: Routes = [
    {
        path: "",
        loadChildren: () => import("./layout/layout.module").then(m => m.LayoutModule),
        canActivate: [AuthGuard]
    },
    {
        path: "login",
        loadChildren: () => import("./login/login.module").then(m => m.LoginModule),
        canActivate: [AuthGuard]
    },
    {   path: "test/:comboId",
        loadChildren: () => import("./test/test.module").then(m => m.TestModule)
    },
    { path: "**", redirectTo: "" }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
